import apiClient from "../../../../lib/api_client";

export const getClientList = async (searchBy) => {
  if (!searchBy) return [];

  try {
    const response = await apiClient.get(
      `/getClientList?searchBy=${encodeURIComponent(searchBy)}`
    );
    return response.data.client || [];
  } catch (error) {
    if (error.response?.status === 404) {
      return [];
    }
    throw error;
  }
};

export const getClientDetail = async (clientCode) => {
  const response = await apiClient.get(`/getSingleClientDetail/${clientCode}`);
  return response.data.clientData;
};
